import api from './api';

export const enterpriseService = {
  async createOrganization(data) {
    return api.post('/enterprise/organization', data);
  },

  async getOrganization() {
    return api.get('/enterprise/organization');
  },

  async inviteMember(data) {
    return api.post('/enterprise/invite', data);
  },

  async getMembers() {
    return api.get('/enterprise/members');
  },

  async getPendingInvitations() {
    return api.get('/enterprise/invitations');
  },

  async acceptInvitation(invitationId) {
    return api.post(`/enterprise/invitations/${invitationId}/accept`);
  },

  async completeOnboarding(data) {
    return api.post('/enterprise/onboarding/complete', data);
  },

  async getInvitation(invitationId) {
    return api.get(`/enterprise/invitations/${invitationId}`, { skipAuth: true });
  },

  async checkDomain(domain) {
    return api.get(`/enterprise/check-domain?domain=${encodeURIComponent(domain)}`, { skipAuth: true });
  },

  async requestAccess() {
    return api.post('/enterprise/request-access');
  },

  async getPendingRequests() {
    return api.get('/enterprise/requests');
  },

  async approveRequest(membershipId) {
    return api.post(`/enterprise/requests/${membershipId}/approve`);
  },

  async rejectRequest(membershipId) {
    return api.post(`/enterprise/requests/${membershipId}/reject`);
  },

  async updateOrganization(data) {
    return api.put('/enterprise/organization', data);
  },

  async updateMemberRole(membershipId, role) {
    return api.put(`/enterprise/members/${membershipId}/role`, { role });
  },

  async transferOwnership(newOwnerId) {
    return api.post('/enterprise/transfer-ownership', { newOwnerId });
  },

  async forceTransferOwnership(newOwnerId) {
    return api.post('/enterprise/force-transfer-ownership', { newOwnerId });
  }
};

export default enterpriseService;
